'use client'
import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import Chevron from '@/assets/images/icons/icon-chevron-down.svg'

/**
 * Props for `Glossary`.
 */
export type GlossaryProps = SliceComponentProps<Content.GlossarySlice>;

/**
 * Component for "Glossary" Slices.
 */
const Glossary: FC<GlossaryProps> = ({ slice }) => {

  const toggleTerm =(e: any) => {
    e.target.parentNode.parentNode.childNodes[1].classList.toggle("hidden");
  }

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation} 
      className={`${slice.primary.style} font-fellix`}
    >
      <div className={`max-w-[1280px] mx-auto px-4 md:px-8 xl:px-0 py-16`}>
        <article className="text-center py-16 prose prose-p:text-[24px] prose-p:leading-[32px] max-w-[700px] mx-auto prose-p:my-16">
          <PrismicRichText field={slice.primary.intro}/>
        </article>
        <div className="grid grid-cols-12 gap-4">
          {slice.primary.terms.map((item: any, index: number)=>{
            return (
                <div className="col-span-12 md:col-span-4 w-full " key={index}>
                  <div className="flex w-full justify-betweeen text-[18px] cursor-pointer hover:opacity-60" onClick={(e: any)=>toggleTerm(e)}>
                    <p className=" w-full block">{item.term}</p>
                    <Chevron className="stroke-jade w-[27px]"/>
                  </div>
                  <div className="hidden pt-4 pr-12">
                    <PrismicRichText field={item.definition} />
                  </div>
                  <div className="border-b-[1px] border-b-jade pb-4 mb-8"></div>
                </div>
              )
            })}
          </div>
      </div>
    </section>
  );
};

export default Glossary;
